import React from "react";
import { FaArrowLeft } from "react-icons/fa";

const BackButton = ({ onClick, label = "Back", className = "" }) => (
  <button
    onClick={onClick}
    className={`flex items-center text-[#3587B8] hover:text-[#2c6d95] ${className}`}
  >
    <FaArrowLeft className="mr-1" />
    <span className="text-sm font-medium">{label}</span>
  </button>
);

export default BackButton;
